/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OptionsInputs */

const en_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options`)
};

const fr_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options`)
};

const de_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen`)
};

const it_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni`)
};

const ru_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры`)
};

const es_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones`)
};

const zh_cn2_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选项`)
};

const ja_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプション`)
};

const hi_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विकल्प`)
};

const pt_pt2_options = /** @type {(inputs: OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções`)
};

/**
* | output |
* | --- |
* | "Options" |
*
* @param {OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options = /** @type {((inputs?: OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options(inputs)
	if (locale === "de") return de_options(inputs)
	if (locale === "it") return it_options(inputs)
	if (locale === "ru") return ru_options(inputs)
	if (locale === "es") return es_options(inputs)
	if (locale === "zh-CN") return zh_cn2_options(inputs)
	if (locale === "ja") return ja_options(inputs)
	if (locale === "hi") return hi_options(inputs)
	if (locale === "pt-PT") return pt_pt2_options(inputs)
	return en_options(inputs)
});